module.exports = __webpack_public_path__ + "static/code-d032fcd86b1edf161b3daac267d21191.svg";